<template>
    <div class = "container">
        <div class="tableDiv">
            <div class="titleDiv"><span>{{ this.sbsj}}各大队服装回收工作项目考评(5分)</span></div>
            <el-table :data="data" border highlight-current-row style="width: 49%">
                <el-table-column v-if="hideIdColumn" prop="id" label="ID"></el-table-column>
                <el-table-column
                        label="序号"
                        type="index"
                        width="50"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="bmmc"
                        label="大队"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="tgrs"
                        label="退工人数"
                        width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="thfzrs"
                        label="退还服装人数"
                        width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="bfb"
                        label="百分比"
                        width="150"
                        align="center">
                        <template slot-scope="scope">
                            {{ scope.row.bfb ? scope.row.bfb + '%' : '' }}
                        </template>
                </el-table-column>
                <el-table-column
                        prop="df"
                        label="得分"
                        width="120"
                        align="center">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                data: [],
                sbsj: ''
            }
        },
        computed: {
        },
        created(){
            this.getDate();
            
        },
        methods: {
            getDate() {
                this.sbsj =  this.$route.params.sbsj
                this.$request.get('/bjba/khxx/fzhs/getFzhsInfoByMonth',{
                    params: {bbsj:this.sbsj}
                }).then(res => {
                    if(res.data.code === 200){                 
                        this.data = res.data.data
                    }
                })
            }
        }
    };
</script>
<style scoped>
    body, html {
    height: 100%;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    }
    
    .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .tableDiv {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .titleDiv {
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: bold;
    }
    el-table {
        width: 100%;
    }
   
</style>